

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// getTierById
// GETTIERBYID
const GETTIERBYID= createAsyncThunk(
  "getTierById/getTierById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getTierByIdSlice = createSlice({
  name: "getTierByIdSlice",
  initialState: {
    getTierById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetTierById: (state) => {
        state.getTierById.loading = false
        state.getTierById.error = false
        state.getTierById.data = []
        state.getTierById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETTIERBYID.fulfilled, (state, action) => {
      state.getTierById = {
        ...state.getTierById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETTIERBYID.pending, (state, action) => {
      state.getTierById = {
        ...state.getTierById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETTIERBYID.rejected, (state, action) => {
      state.getTierById = {
        ...state.getTierById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getTierByIdAction = {
    GETTIERBYID,
};

export { getTierByIdAction };
export default getTierByIdSlice.reducer;
export const {setInitialStateOfgetTierById} = getTierByIdSlice.actions
